import { isClient } from '@/components/base/utils'
import { CLIENT_PUBLIC_URL, PUBLIC_URL } from '@/utilities/stateTool'

import { putOwnerUser } from '../dexie/ownerDexie'
import { saveUserDataToDexie, tokenUpdate } from '../dexie/userDexie'
import { stepinAuthInstance } from '../stepinApi/auth'

const { POST } = stepinAuthInstance

export const doSignInWithGoogle2 = async (callback: string) => {
	const details = {
		// client_id: '799005040887-gpmv6rbpfob9j6hrv073us1vg3lb5p9t.apps.googleusercontent.com',
		client_id: '799005040887-1q1dfi9sgasnmfo0f963ff88amc2n8nc.apps.googleusercontent.com',
		redirect_uri: PUBLIC_URL + '/auth/google?link=' + callback,
		response_type: 'token',
		// scope: 'email openid profile',
		scope: 'profile',
	}
	const sp = new URLSearchParams(details)
	window.location.href = 'https://accounts.google.com/o/oauth2/auth?' + sp.toString()
}

/**
 * 애플 로그인은 스크립트를 head script를 통해 init된게 사용됨
 * @param callback 소셜 컴포넌트를 signin과 signup에서 같이 사용하고 있고 그 구분을 login , signup으로 관리하고 있음 그 값을 그대로 가져온다
 */
export const doSignInWithApple = async (callback: string) => {
	window.AppleID.auth.init({
		clientId: 'com.sidewalkplay.stepin',
		scope: 'name email',
		redirectURI: PUBLIC_URL,
		usePopup: true,
	})

	const res = await window.AppleID.auth.signIn()
	login(res, callback)
}

const login = async (res: AppleSignInAPI.SignInResponseI, callback: string, relay = 0) => {
	if (relay > 2) return
	if (callback === 'login') {
		const { data, response, error } = await POST('/auth/signin/web/oauth', {
			body: {
				socialType: 'APPLE',
				accessToken: res.authorization.id_token,
			},
		})
		if (data) {
			await tokenUpdate(response)
			await saveUserDataToDexie(data.data)
			await putOwnerUser()
			if (isClient) window.location.href = CLIENT_PUBLIC_URL
		} else if (response.status === 403) {
			// 결과 올 때까지 기다리니까 바로 보내도 괜찮음
			login(res, 'signup', ++relay)
		}
	}
	if (callback === 'signup') {
		const { data, response } = await POST('/auth/signup/oauth', {
			body: {
				socialType: 'APPLE',
				accessToken: res.authorization.id_token,
				marketingTerms: true,
			},
		})
		if (data) {
			login(res, 'login')
		}
	}
}
